import { useState, useErrorBoundary } from 'preact/hooks';


export const ErrorBoundary = (props) => {
	const { children, fallback: Fallback } = props;

	const [error, setError] = useState();
	useErrorBoundary(setError);

	if (error) {
		return <Fallback error={error} reset={() => setError()} />
	}

	return children;
};

export const useBoundError = (givenError) => {
	const [error, setError] = useState(givenError);

	if (error) {
		throw error;
	}

	return setError;
};
